const reducer = (state = {}, action) => {
    switch (action.type) {
        case "LOGIN_USER": {
            return { ...state, user: action.user }
        }
        case "REMOVE_USER": {
            return { ...state, user: null }
        }
        case "PROMOTION_ADS": {
            return { ...state, ads: action.ads }
        }
        default: {
            return state;
        }
    }
}
export default reducer